import React, { useState, useEffect } from "react";
import MarkdownPanel from "components/ChatGPT/MarkdownPanel";
const MarkdownTypewriter = ({ text, textDelay, overrides, chunkSize, startupDelay, replaceText }) => {
    const [renderedText, updateRenderedText] = useState("");
    const [currentIndex, updateCurrentIndex] = useState(0);
    const [delayBeforeStart, updateDelayBeforeStart] = useState(Boolean(startupDelay));
    const stringChunkSize = chunkSize ?? 5;
    const strChunks = [];
    for (let i = 0; i < text?.length; i += stringChunkSize) {
        strChunks.push(text.slice(i, i + stringChunkSize));
    }
    const remainingChunks = strChunks?.length - currentIndex;
    const retDelay = textDelay
        ? textDelay
        : remainingChunks > 10
            ? 16
            : remainingChunks > 5
                ? 30
                : Math.min(150 / Math.max(remainingChunks, 1), 125);
    useEffect(() => {
        if (replaceText) {
            updateRenderedText("");
            updateCurrentIndex(0);
        }
    }, [text]);
    const updateAndRenderText = () => {
        const retText = strChunks.slice(0, currentIndex + 1).join("");
        updateRenderedText(retText);
        if (currentIndex < strChunks.length - 1) {
            updateCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };
    useEffect(() => {
        let delayTimer;
        if (delayBeforeStart && startupDelay) {
            delayTimer = setTimeout(() => {
                updateAndRenderText();
            }, startupDelay);
            updateDelayBeforeStart(false);
        }
        else if (currentIndex < strChunks.length) {
            delayTimer = setTimeout(() => {
                updateAndRenderText();
            }, retDelay);
        }
        return () => clearTimeout(delayTimer);
    }, [currentIndex, textDelay, text]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MarkdownPanel, { overrides: overrides }, renderedText)));
};
export default MarkdownTypewriter;
